/* sb-dc-issuefold.js — show two check results, fold the rest behind an arrow.
   2026-09-05.

   The approve dialog lists every finding at full height. Two of them fill the
   panel; ten push the acknowledgement checkbox and the add-on tick boxes so far
   down that a customer has to scroll past a wall of red to find the thing they
   are supposed to click. The reaction is not "let me fix these", it is "this
   is broken, I'll leave".

   sb-dc-quiet.js already took the design opinions out, so the list is usually
   one line or empty now. This is the guard for when it is not: a design with
   several real blocks, or a future check we add back. Two is enough to show
   what kind of problem it is; the rest is one click away.

       Blocked   The design is empty
       Blocked   This is a double-sided product but the back is empty
       ⌄ Show 3 more

   Nothing is removed — the entries stay in the list and in the count, they are
   only not drawn until asked for. sb-dc-override.js reads
   `.proof-issues li.is-block` to decide whether to offer "Order anyway?", and
   folded rows still match that selector, so the waiver keeps working whether
   the list is open or shut.

   The button is appended as the LAST child of section.proof-issues, never
   inserted between the nodes React made, and it is rebuilt whenever React
   repaints the dialog — the same arrangement sb-dc-override.js uses.

   A new set of findings starts folded again, so a customer who opened the list
   on one design does not land on a wall of text on the next.

   Diagnostics: window.__dcIssueFold. */
(function () {
  'use strict';

  var SHOWN = 2;                       // 접었을 때 보여 줄 줄 수
  var state = { open: false, key: '', count: 0, folded: false };
  window.__dcIssueFold = state;

  function css() {
    if (document.getElementById('sbdc-issuefold-css')) return;
    var st = document.createElement('style');
    st.id = 'sbdc-issuefold-css';
    st.textContent = [
      /* ul 은 flex 라 되돌릴 때도 flex 여야 한다 (sb-dc-app.css: .proof-issues ul) */
      '.proof-issues ul.sbdc-fold > li:nth-child(n+' + (SHOWN + 1) + '){display:none}',
      '.proof-issues ul.sbdc-fold.is-open > li:nth-child(n+' + (SHOWN + 1) + '){display:flex}',
      '.sbdc-issuemore{display:flex;align-items:center;gap:6px;margin:8px 0 0;padding:7px 11px;',
      'width:100%;background:none;border:0;border-radius:3px;cursor:pointer;',
      'color:var(--ink-2,#415457);font:600 12.5px/1.4 var(--sans,system-ui,sans-serif)}',
      '.sbdc-issuemore:hover{background:var(--surface-2,#e8edee)}',
      '.sbdc-issuemore:focus-visible{outline:2px solid var(--focus,#00697f);outline-offset:1px}',
      '.sbdc-issuemore i{font-style:normal;font-size:11px;transition:transform .12s ease}',
      '.sbdc-issuemore[aria-expanded="true"] i{transform:rotate(180deg)}'
    ].join('\n');
    document.head.appendChild(st);
  }

  /* 목록이 바뀌면 다시 접는다 — 줄 수와 첫 줄 제목이면 충분히 구별된다 */
  function keyOf(items) {
    var first = items[0] && items[0].querySelector('b');
    return items.length + '~' + ((first && first.textContent) || '').slice(0, 40);
  }

  /* ⚠ 이 함수는 반드시 «바뀔 때만» DOM 을 건드려야 한다. 우리는
     document.body 를 subtree 로 감시하고 있어서, 여기서 무조건 다시 그리면
     그 변경이 감시자를 깨우고 감시자가 다시 여기를 불러 영원히 돈다.
     (실제로 그렇게 만들었다가 브라우저가 멎었다 — 2026-09-05)
     sb-dc-override.js 가 «없을 때만 만든다» 로 같은 함정을 피한다. */
  function label(btn, hidden) {
    var want = state.open ? 'Show less' : 'Show ' + hidden + ' more';
    var open = state.open ? 'true' : 'false';
    if (btn.getAttribute('data-sbdc-label') === want &&
        btn.getAttribute('aria-expanded') === open) return;      // 바뀐 것이 없다
    btn.setAttribute('data-sbdc-label', want);
    btn.setAttribute('aria-expanded', open);
    btn.textContent = '';
    var i = document.createElement('i');
    i.textContent = '▾';
    i.setAttribute('aria-hidden', 'true');
    btn.appendChild(i);
    btn.appendChild(document.createTextNode(want));
  }

  function tick() {
    var sec = document.querySelector('.proof-issues');
    var ul = sec && sec.querySelector('ul');
    var old = sec && sec.querySelector('.sbdc-issuemore');
    if (!ul) { state.folded = false; state.count = 0; return; }

    var items = ul.children;
    state.count = items.length;

    if (items.length <= SHOWN) {                    // 접을 것이 없다
      ul.classList.remove('sbdc-fold', 'is-open');
      if (old && old.parentNode) old.parentNode.removeChild(old);
      state.folded = false;
      return;
    }

    var key = keyOf(items);
    if (key !== state.key) { state.key = key; state.open = false; }   // 새 목록은 접힌 채로

    css();
    ul.classList.add('sbdc-fold');
    ul.classList.toggle('is-open', state.open);
    state.folded = true;

    var hidden = items.length - SHOWN;
    var btn = old;
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sbdc-issuemore';
      btn.addEventListener('click', function () {
        state.open = !state.open;
        try { tick(); } catch (e) {}
      });
      sec.appendChild(btn);                          // React 가 만든 노드 «사이» 에 끼우지 않는다
    }
    label(btn, hidden);
  }

  function start() {
    try {
      var mo = new MutationObserver(function () { try { tick(); } catch (e) {} });
      mo.observe(document.body, { childList: true, subtree: true });
      window.addEventListener('pagehide', function () { mo.disconnect(); });
      tick();
    } catch (e) { /* 접기가 승인 창을 막지는 않는다 */ }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
